import type { SVGProps } from 'react';
import { INTEGRATION_BRANDS } from '@/lib/brand/integration-brands';

const Square = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" fill={INTEGRATION_BRANDS.square.primary}>
    <path d="M4.01 2A2.01 2.01 0 0 0 2 4.01v15.98C2 21.1 2.9 22 4.01 22h15.98A2.01 2.01 0 0 0 22 19.99V4.01A2.01 2.01 0 0 0 19.99 2H4.01zm2.04 4.05h11.9a2 2 0 0 1 2 2v7.9a2 2 0 0 1-2 2H6.05a2 2 0 0 1-2-2v-7.9a2 2 0 0 1 2-2zm3.04 2.84v6.22h5.82V8.89H9.09z" />
  </svg>
);

export { Square };
